import React, { useEffect, useState } from "react";
import { Table, Container, Button } from "react-bootstrap";
import classes from "../../WebsiteManagement/websiteManagement.module.css";
import Page from "../../pagination/pagination";

const TourGuideList = (props) => {
  const [dataSet, updateDataSet] = useState([]);
  const [count, updateCount] = useState(0);
  const postPerPage = 20;
  const [currentPage, updateCurrentPage] = useState(1);
  const indexOfLast = currentPage * postPerPage;
  const indexOfFirst = indexOfLast - postPerPage;
  const currentPosts = dataSet.slice(indexOfFirst, indexOfLast);
  const handleChangePage = (event, value) => {
    updateCurrentPage(value);
  };

  const handleclick = (data) => {
    console.log(data);
    props.mydata(data);
    props.click();
  };

  useEffect(() => {
    updateCount(Math.ceil(dataSet.length / postPerPage));
  }, [dataSet]);
  useEffect(() => {
    (async () => {
      const data = {
        emailId: "string",
        password: "string",
        phoneno: "string",
        sessionKey: "string",
      };
      const myresponse = await fetch(
        `https://api.zupptravel.com/getTourGuide`,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );
      const json = await myresponse.json();
      console.log(json);
      if (json.successful) {
        updateDataSet(json.tourGuides);
      }
    })();
  }, []);

  const HandleDelete = async (id) => {
    const newd = {
      emailID: "string",
      id: id,
      sessionKey: "string",
    };
    console.log(newd);
    const r = await fetch("https://api.zupptravel.com/deleteTourGuide", {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newd),
    });
    const j = await r.json();
    if (j.successful) {
      alert("Successfully deleted Tour Guide Inventory");
      const newdata = {
        emailId: "string",
        password: "string",
        phoneno: "string",
        sessionKey: "string",
      };
      const res = await fetch("https://api.zupptravel.com/getTourGuide", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(newdata),
      });
      const json = await res.json();
      if (json.successful) {
        updateDataSet(json.tourGuides);
      }
    }
  };

  console.log("DADA", dataSet);

  return (
    <Container fluid style={{ padding: "0" }}>
      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>S.No</th>
            <th>Tour Guide ID</th>
            <th>Tour Guide Name</th>
            <th>Tour Guide City</th>
            <th>Language</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentPosts.length > 0
            ? currentPosts.map((data, key) => (
                <tr key={key}>
                  <td>{key + 1}</td>
                  <td>{data.tourGuideId}</td>
                  <td>{data.guideName}</td>
                  <td>{data.citiesServed}</td>
                  <td>{data.language}</td>
                  <td className={classes.CenterRow}>
                    <Button
                      style={{ marginRight: "5px" }}
                      variant="danger"
                      onClick={() => HandleDelete(data.id)}
                    >
                      Delete
                    </Button>
                    <Button
                      style={{ marginRight: "5px" }}
                      // onClick={props.click}
                      onClick={() => handleclick(data)}
                    >
                      View
                    </Button>
                    {data.active ? (
                      <Button variant="success">Active</Button>
                    ) : (
                      <Button variant="warning">Inactive</Button>
                    )}
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </Table>
      <div
        style={{ display: "flex", justifyContent: "center", margin: "15px 0" }}
      >
        <Page count={count} change={handleChangePage} page={currentPage} />
      </div>
    </Container>
  );
};
export default TourGuideList;
